<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('customerService.process_refund_transactions')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.refund_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }} {{ merchantInfo.this_time_refund_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.original_transaction_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }} {{ merchantInfo.original_transaction_amount | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('components.create_time') }}</span>
        <span class="content-blue">{{ $t('merchantAccount.complete_time') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.original_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.original_transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.refund_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.refund_transaction_id }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
        <span class="content-gray">{{ getRefundStatusMapLabel(merchantInfo.refund_category) }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.cumulative_amount_refunded') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.refunded_amount) | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.present_refund_amount') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.this_time_refund_amount) | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_fee_change_mode') }}</span>
        <span class="content-gray">{{ getTransactionFeeMode(merchantInfo.fee_split_type) }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.refunded_transaction_fee') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.refund_transaction_fee) | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.actual_refund_amount_received') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.actual_receive_refund_amount) | toDivideWithDot }}</span>
      </div>

      <div class="section-title" />
      <div class="line-bottom-1px" />
      <div class="item">
        <span style="color: #71110e; margin-right: 4px;">*</span>
        <span class="item-left content-gray">{{ $t('customerService.refund_order_status') }}</span>
        <el-radio v-model="search.refund_order_status" label="true">{{ $t('components.cancel') }}</el-radio>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.remark') }}</span>
        <el-input v-model="search.remark" class="mt-12" label="true" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible=false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="!search.refund_order_status" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
      </div>

      <el-tag :type="getRefundTypeMapType(merchantInfo.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(merchantInfo.status) }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { refundCancel, refundDetail } from '@/api/customer-service/customer-service'
import { payTransactionStatusMap, transactionFeeMode, refundTypeMap, refundStatusMap } from '@/utils/maps'
export default {
  name: 'Refund_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      search: {
        refund_order_status: false
      },
      data: {},
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getRefundStatusMapLabel() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    },
    getTansationFeeModeLabel() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    },
    getRefundTypeMapType() {
      return function(value) {
        return refundTypeMap(value).type
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundTypeMap(value).label
      }
    },
    getTransactionFeeMode() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { refund_transaction_id: this.data.refund_transaction_id }
      refundDetail(params).then(res => {
        if (res.code === 10000) {
          this.merchantInfo = res.data
        }
      })
      this.search = {
        refund_order_status: false
      }
    },
    // 改变弹框状态
    changModalStatus(value, data) {
      this.dialogTableVisible = value
      this.data = data
    },
    onClickSubmitBtn() {
      const params = { refund_transaction_id: this.data.refund_transaction_id, remark: this.search.remark }
      refundCancel(params).then(res => {
        if (res.code === 10000) {
          this.search = {
            refund_order_status: false
          }
          this.dialogTableVisible = false
          this.$emit('updateList')
          this.$message.success('Success')
        }
      })
    },
    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payMentDetails .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payMentDetails .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}
.mt-12{
  margin-top: 12px;
}
</style>
